import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { DISCOUNT_TYPE } from '@umu/umu-types';
export { DISCOUNT_TYPE } from '@umu/umu-types';

export interface ISurfacePricing {
    package: string;
    amount: number;
    amount_settle: number;
    discount: number;
    discount_type?: DISCOUNT_TYPE;
    discount_expire_date: string;
    is_surface: string;
    product_id: string;
    product_name: string;
    months: number;
    desc: string;
    currency: string;
}
export interface IOutput {
    [key: string]: ISurfacePricing;
}

interface Input {
    plan_ids: string,
    package_type: number,
}

export const getAccountPlanSurfaceList = (param: Input): Promise<IResponse<IOutput>> => {
	return fetchData(Api.GET_PLAN_PRICING, param).then((res: IResponse<IOutput>) => {
		return res;
	});
};
